// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1hGKP","right":"Footer_right__32KvM","buttons":"Footer_buttons__hWR5G"};